// hooks/useRouteTracker.ts
import { useEffect } from 'react';

import { isActiveAnnotatorRouteAtom } from '@repo/videa-notes';
import { useSetAtom } from 'jotai';
import { matchPath, useLocation } from 'react-router-dom';

export const useTrackActiveRoute = () => {
  const location = useLocation();
  const setIsActive = useSetAtom(isActiveAnnotatorRouteAtom);

  useEffect(() => {
    // Extract the pathname from the hash (strip off `#` and any query/hash fragments)
    const hashPath = location.hash.replace(/^#/, '').split(/[?#]/)[0];

    // Check for all possible annotator route patterns
    const isMatch = !!matchPath(hashPath, [
      '/annotator/:id',
      '/annotator/:id/:imageId',
      '/embedded/annotator/:id',
      '/embedded/annotator/:id/:imageId',
    ]);
    setIsActive(isMatch);
  }, [location, setIsActive]);
};
